// extracted by mini-css-extract-plugin
module.exports = {"logo":"Q_9","logo__element":"Q_cb","back":"Q_bj"};